import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7796e966")

_pushScopeId("data-v-7796e966")
const _hoisted_1 = { class: "sceneEditBox" }
const _hoisted_2 = { class: "sceneEditBox-wrap" }
const _hoisted_3 = { class: "seb-header mb24" }
const _hoisted_4 = { class: "seb-header-title flex align-items-center" }
const _hoisted_5 = { class: "title-text flex1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_8 = { class: "seb-header-content" }
const _hoisted_9 = { class: "seb-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_a_menu = _resolveComponent("a-menu")
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined")
  const _component_a_dropdown = _resolveComponent("a-dropdown")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_SvgIcon, {
            class: "my-icon",
            icon: "back2",
            onClick: _ctx.back
          }, null, 8, ["onClick"]),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.props.editItem.roleName), 1),
          _createVNode(_component_a_dropdown, {
            trigger: ["click"],
            overlayStyle: { boxShadow: "0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12)" }
          }, {
            overlay: _withId(() => [
              _createVNode(_component_a_menu, { onClick: _ctx.change }, {
                default: _withId(() => [
                  _createVNode(_component_a_menu_item, {
                    class: "align-center mb8",
                    key: "1"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_a_button, { class: "btn-enable my-btn-small" }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (!_ctx.props.isEdit)
                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                        class: "align-center",
                        key: "0"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_a_button, { class: "btn-disable my-btn-small" }, {
                            default: _withId(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withId(() => [
              _createVNode(_component_a_button, {
                class: ["my-btn", { "btn-enable": _ctx.btnItem.btnStyle, "btn-disable": !_ctx.btnItem.btnStyle }],
                loading: _ctx.props.loading
              }, {
                icon: _withId(() => [
                  _createVNode(_component_CaretRightOutlined)
                ]),
                default: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.btnItem.text), 1)
                ]),
                _: 1
              }, 8, ["class", "loading"])
            ]),
            _: 1
          }, 8, ["overlayStyle"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_a_spin, {
            spinning: _ctx.props.loading
          }, {
            default: _withId(() => [
              _renderSlot(_ctx.$slots, "headerContent")
            ]),
            _: 3
          }, 8, ["spinning"])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ])
  ]))
})